module.exports = __webpack_public_path__ + "static/media/Shapesgrey.f906a69b.svg";